import { BitrixVue } from 'ui.vue';

BitrixVue.component('Input', {
	data() {
		return {
			inputValue: this.value ? this.value : '',
		};
	},
	props: ['state', 'label', 'name', 'placeholder', 'value', 'watchingData'],
	methods: {
		changeValue() {
			this.$emit('changeValue', this.inputValue);
		},
	},
	watch: {
		watchingData(value) {
			this.changeValue();
		},
	},
	template: `
		<div class="config-field__block">
			<div v-if="this.label" class="config-select__title">{{this.label}}</div>
			<ui-textbox 
				:placeholder="this.placeholder" 
				:name="this.name"
				:value="this.value"
				class="custom-input"
				v-model="inputValue" 
				@input="changeValue"
			></ui-textbox>
		</div>
		`,
});
